import { render, staticRenderFns } from "./indexCopy.vue?vue&type=template&id=0b29bd7f&scoped=true&"
import script from "./indexCopy.vue?vue&type=script&lang=js&"
export * from "./indexCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b29bd7f",
  null
  
)

export default component.exports